import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Input, Label, Button, Select } from "@windmill/react-ui";
import { ImFacebook, ImGoogle } from "react-icons/im";
import Swal from "sweetalert2";

import InputArea from "../components/form/InputArea";
import LabelArea from "../components/form/LabelArea";
import SelectRole from "../components/form/SelectRole";
import useLoginSubmit from "../hooks/useLoginSubmit";
import ImageLight from "../../client/assets/FInalLogo.png";
// API
import { operatorSignup } from "../../actions/auth";
// Redux
import { connect } from "react-redux";
import propTypes from "prop-types";
import store from "../../store";
import termpdf from '../assets/Bus Arabia Terms and Conditions.pdf'

const OperatorSignup = ({ operatorSignup }) => {
  const history = useHistory();
  const { onSubmit, register, loading } = useLoginSubmit();
  const [confirmPassword, setConfirmPassword] = useState('')



  const [user, setUser] = useState({
    name: "",
    email: "",
    operatorName: "",
    password: "",
    role: "",
    privacyPolicy: false,
  });


  const changeConfirmPassword = (e) => {
    setConfirmPassword(e.target.value)
  }


  const handleUser = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {


    if (!user.email || !user.password || !confirmPassword || !user.operatorName) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please fill in all fields before submitting.",
      });
      return;
    }

    if (user.password.length < 8) {
      Swal.fire({
        icon: "error",
        title: "Weak Password",
        text: "Password must be at least 8 characters long.",
      });
      return;
    }


    if (confirmPassword != user.password) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please reenter your password. Password & Confirm Password should be same!",
      });
      return;
    }

    if (!user.privacyPolicy) {
      Swal.fire({
        icon: "warning",
        title: "Privacy Policy Required",
        text: "You must agree to the privacy policy before signing up.",
      });
      return;
    }


    let signupObj = {
      operatorName: user.operatorName,
      email: user.email,
      password: user.password,
      role: "operator",
      privacyPolicy: user.privacyPolicy
    };

    operatorSignup(signupObj, history);
  };

  console.log(user, "userdfqw")


  return (
    <div className="flex items-center min-h-screen p-6 bg-gray-50">
      <div className="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-md">
        <div className="flex flex-col overflow-y-auto md:flex-row">
          <div className="h-32 md:h-auto md:w-1/2 operLogoOuter">
            <img
              aria-hidden="true"
              className="operatorLogo"
              src={ImageLight}
              alt="Office"
            />
          </div>
          <main className="flex items-center justify-center p-6 sm:p-12 md:w-1/2">
            <div className="w-full">
              <h1 className="mb-6 text-2xl font-semibold text-gray-700">
                Create account
              </h1>


              <LabelArea label="Company Name" />
              <InputArea
                name="operatorName"
                type="text"
                placeholder="Company Name"
                onChange={(e) => handleUser(e)}
              />


              <LabelArea label="Email" />
              <InputArea
                label="Email"
                name="email"
                type="email"
                placeholder="john@doe.com"
                onChange={(e) => handleUser(e)}
              />

              <LabelArea label="Password" />
              <InputArea
                label="Password"
                name="password"
                type="password"
                placeholder="***************"
                onChange={(e) => handleUser(e)}
              />
              <LabelArea label="Confirm Password" />
              <InputArea
                value={confirmPassword}
                type="password"
                placeholder="***************"
                onChange={changeConfirmPassword}
              />


              <Label className="mt-6" check>
                <Input
                  type="checkbox"
                  checked={user.privacyPolicy}
                  onChange={(e) =>
                    setUser({ ...user, privacyPolicy: e.target.checked })
                  }
                />
                <span className="ml-2">
                  I agree to the Terms and Conditions mentioned in the Bus Operators Terms and Conditions Document, {" "}
                  <a href={termpdf} target="_blank" style={{ color: "black" }} className="underline" rel="noopener noreferrer">
                    click here to read this document
                  </a>
                </span>
              </Label>

              <Button
                disabled={loading}
                type="submit"
                className="mt-4 h-12 w-full newBtnColor"
                onClick={handleSubmit}
                block
              >
                Create account
              </Button>

              <hr className="my-10" />


              <p className="mt-4">
                <Link
                  className="text-sm font-medium noTextDecor hover:underline"
                  to="/operator/login"
                >
                  Already have an account? Login
                </Link>
              </p>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

OperatorSignup.propTypes = {
  operatorSignup: propTypes.func.isRequired,
};

export default connect(null, { operatorSignup })(OperatorSignup);
